import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';

export function selectServiceIds(state: IAppState): Array<EServiceId> {
  return state.servicePickerWidget.publishTerms.serviceIds;
}
